import { useEffect , useRef } from "react"
import { nameSede } from 'src/shared/global/helpers';

export default function useSEO({ title }) {

    const prevTitle =  useRef(document.title)

    const setTitle = title => {
        // const el = document.querySelector('title');
        // el.innerText = `${el.text} | ${title}`;
        const el = document.querySelector("meta[name='title']");
        el.setAttribute('content',title);

      };
    
    const setDescription = desc => {
        const el = document.querySelector("meta[name='description']");
        el.setAttribute('content',desc)
      }

    useEffect(() => {
        const previousTitle =  prevTitle.current
        document.title = `${title}: ${nameSede(process.env.REACT_APP_SEDE)}`    
        setTitle(`${title}: ${nameSede(process.env.REACT_APP_SEDE)}`);
        setDescription(`Reserva hora con nuestros profesionales en ${nameSede(process.env.REACT_APP_SEDE)}. Tenemos más de 80 especialidades disponibles.`);

        return () => document.title = previousTitle
    }, [title])
}